import Portal, { SIDEBAR_NAV_ITEMS } from '~/classes/Portal';
import { AccountDisplayStatus } from '~/classes/User';
import { PATHS } from '~/router';
import { userStore } from '~/utils/store-accessor';
/* Deep Copy of general SIDEBAR_NAV_ITEMS adapted for BPK */
const BPK_SIDEBAR_NAV_ITEMS = JSON.parse(JSON.stringify(SIDEBAR_NAV_ITEMS)).filter((item) => {
    if (item.path === PATHS.ACCOUNT.INDEX) {
        item.text = 'Beiträge';
    }
    return item.path !== PATHS.REQUESTS.INDEX;
});
class BPKPortal extends Portal {
    constructor() {
        super(...arguments);
        this.sidebarNavItems = BPK_SIDEBAR_NAV_ITEMS;
    }
    canAccessAccount() {
        return super.canAccessAccount() &&
            !!userStore.user &&
            !userStore.user.hasAllAccountsDeactivated() &&
            userStore.user.hasAccountDisplayStatus(AccountDisplayStatus.OK);
    }
    canAccessRequests() {
        return false;
    }
}
export default new BPKPortal({
    key: 'bpk',
    matomoSiteId: 4
});
